// 手风琴动画（鼠标停留0.1秒才触发 active）
const initAccordionImage = function () {
  const items = document.querySelectorAll('.accordion-image__item');
  
  items.forEach(item => {
    let hoverTimer = null;

    item.addEventListener('mouseover', function () {
      // 设置一个定时器，0.1秒后才执行激活逻辑
      hoverTimer = setTimeout(() => {
        if (this.classList.contains('active')) return;

        // 当前将变成 active 的项
        const currentDesc = this.querySelector('.accordion-image__desc');
        if (currentDesc) {
          // 先立即透明（无过渡）
          currentDesc.style.transition = 'none';
          currentDesc.style.opacity = '0';

          // 强制重绘
          void currentDesc.offsetWidth;

          // 再添加过渡并恢复透明度
          setTimeout(() => {
            currentDesc.style.transition = 'opacity 0.36s ease';
            currentDesc.style.opacity = '1';
          }, 360);
        }

        // 处理所有将失去 active 的元素
        items.forEach(el => {
          if (el !== item && el.classList.contains('active')) {
            const oldDesc = el.querySelector('.accordion-image__desc');
            if (oldDesc) {
              oldDesc.style.transition = 'none';
              oldDesc.style.opacity = '0';
              void oldDesc.offsetWidth;
              setTimeout(() => {
                oldDesc.style.transition = 'opacity 0.36s ease';
                oldDesc.style.opacity = '1';
              }, 360);
            }
          }
          el.classList.remove('active');
        });

        // 给当前元素加 active
        item.classList.add('active');
      }, 100); // 停留 0.1 秒
    });

    item.addEventListener('mouseout', function () {
      // 如果鼠标移出，清除定时器
      clearTimeout(hoverTimer);
    });
  });
};


// 折叠卡片动画
/**
 * 初始化折叠卡片动画，同时同步右侧的item
 * @param {string|HTMLElement} containerSelectorOrElement - 左侧容器选择器或元素
 * @param {Object} options - 配置项
 * @param {string} options.itemSelector - 左侧每一项的选择器（默认 '.left__item'）
 * @param {string} options.contentSelector - 左侧每一项内容的选择器（默认 '.left__item-content'）
 * @param {string} [options.rightItemSelector] - （可选）右侧每一项的选择器
 */
const initFoldedCard = function (containerSelectorOrElement, options = {}) {
  const {
    itemSelector = '.left__item',
    contentSelector = '.left__item-content',
    rightItemSelector, // 右侧item选择器
  } = options;

  const container = typeof containerSelectorOrElement === 'string'
    ? document.querySelector(containerSelectorOrElement)
    : containerSelectorOrElement;

  if (!container) {
    return;
  }

  const items = container.querySelectorAll(itemSelector);
  if (items.length === 0) {
    return;
  }

  const rightItems = rightItemSelector
    ? document.querySelectorAll(rightItemSelector)
    : null;

  // 默认展开第一个
  const firstItem = items[0];
  const firstContent = firstItem.querySelector(contentSelector);
  firstItem.classList.add('active');
  
  // 等待浏览器完成布局后再设置 maxHeight，确保高度准确
  requestAnimationFrame(() => {
    firstContent.style.maxHeight = firstContent.scrollHeight + 'px';
    firstContent.style.opacity = '1';
  });

  // 如果有右侧区域，同步第一个
  if (rightItems) {
    rightItems.forEach((ri, idx) => {
      ri.classList.toggle('active', idx === 0);
    });
  }

  items.forEach((item, index) => {
    item.addEventListener('click', () => {
      if (item.classList.contains('active')) return;

      const currentActive = container.querySelector(`${itemSelector}.active`);
      if (!currentActive) return;

      const oldContent = currentActive.querySelector(contentSelector);
      const newContent = item.querySelector(contentSelector);

      // 收起旧项
      oldContent.style.maxHeight = oldContent.scrollHeight + 'px';
      oldContent.style.opacity = '1';

      requestAnimationFrame(() => {
        oldContent.style.maxHeight = '0px';
        oldContent.style.opacity = '0';
      });

      currentActive.classList.remove('active');

      // 展开新项
      newContent.style.maxHeight = '0px';
      newContent.style.opacity = '0';
      item.classList.add('active');

      requestAnimationFrame(() => {
        newContent.style.maxHeight = newContent.scrollHeight + 'px';
        newContent.style.opacity = '1';
      });

      // 同步右侧区域
      if (rightItems) {
        rightItems.forEach((ri, idx) => {
          ri.classList.toggle('active', idx === index);
        });
      }
    });
  });
}


document.addEventListener('DOMContentLoaded', () => {
  // 加载手风琴动画
  initAccordionImage();
  
  // 加载折叠动画
  initFoldedCard('.folded-card__left-1', {
    itemSelector: '.left__item',
    contentSelector: '.left__item-content',
    rightItemSelector: '.right-group-1 .right__item'
  });
  initFoldedCard('.folded-card__left-2', {
    itemSelector: '.left__item',
    contentSelector: '.left__item-content',
    rightItemSelector: '.right-group-2 .right__item'
  });
  
  // swiper加载
  var partSixSwiper = new Swiper('.all-in-one__swiper_container', {
    autoplay: false,//可选选项，自动滑动
    effect: 'fade',
    pagination: {
      el: ".all-in-one__swiper_container .swiper-pagination",
      clickable: true,
      renderBullet: function (index, className) {
        return '<span class="' + className + '">' + (index + 1) + "</span>";
      },
      renderBullet: function (index, className) {
        switch (index) {
          case 0:
            text = "Movie";
            break;
          case 1:
            text = "Gaming";
            break;
          case 2:
            text = "Sports";
            break;
          case 3:
            text = "Family Entertainment";
            break;
        }
        return '<span class="' + className + '">' + text + "</span>";
      },
    },
  });
  var accordionImageSwiper = new Swiper('.accordion-image__swiper-container', {
    autoplay: false,//可选选项，自动滑动
    slidesPerView: window.innerWidth > 767 ? 2.5 : 1.5,
    spaceBetween: 8,
    pagination: {
      el: '.accordion-image__swiper-container .swiper-pagination',
    },
    navigation: {
      nextEl: '.accordion-image__swiper-container .swiper-button-next',
      prevEl: '.accordion-image__swiper-container .swiper-button-prev',
    }
  });
  
  // 初始化隐藏和显示
  document.querySelectorAll(".f_nameAndprice").forEach(el => el.style.display = "none");
  document.querySelectorAll(".f_active").forEach(el => el.style.display = "");
  
  // 监听所有 .prodcut_variant_select 的 change 事件
  document.querySelectorAll(".prodcut_variant_select").forEach(select => {
    select.addEventListener("change", function () {
      const parentElement = select.closest(".product-container") || select.parentElement.parentElement;
      const selectedIndex = select.selectedIndex;
      const numberOfOptions = select.options.length - 1;
  
      const selectedOption = select.options[selectedIndex];
      const data_url = selectedOption.getAttribute("data-url");
      const data_vid = selectedOption.getAttribute("data-vid");
  
  
      // 更新链接和按钮属性
      parentElement.querySelectorAll(".product_name, .learn_more").forEach(link => {
        link.setAttribute("href", data_url);
      });
  
      parentElement.querySelectorAll(".checkout").forEach(btn => {
        btn.setAttribute("data-id", data_vid);
      });
  
      // 隐藏所有价格组
      parentElement.querySelectorAll(".f_nameAndprice").forEach(el => el.style.display = "none");
  
      // 显示匹配的 [data-*] 元素
      const showIndex = numberOfOptions - selectedIndex;
      ["data-screensize", "data-stationsize", "data-thundersize", "data-cabinet"].forEach(attr => {
        const target = parentElement.querySelectorAll(`[${attr}]`)[showIndex];
        if (target) target.style.display = "";
      });
    });
  });
  
  // 滚动动画
  const scrollSection = document.getElementById('scrollSection');
  const imageWrapper = document.getElementById('imageWrapper');
  const images = imageWrapper.querySelectorAll('.part-four__img');
  const descItems = document.querySelectorAll('.image-desc__item');
  const numImages = images.length;
  
  let currentActiveIndex = 0;
  images[0].style.opacity = 1;
  descItems[0].classList.add('active');
  
  setTimeout(() => {
    const firstItem = descItems[0];
    const firstContent = firstItem.querySelector('.image-desc__item .item-body');
    if (firstContent) {
      firstItem.classList.add('active');
      firstContent.style.maxHeight = firstContent.scrollHeight + 'px';
      firstContent.style.opacity = '1';
    }
  }, 50);
  
  // 节流函数：限制回调函数调用的频率
  function throttle(fn, delay) {
    let lastTime = 0;
    return function() {
      const now = new Date().getTime();
      if (now - lastTime >= delay) {
        lastTime = now;
        fn.apply(this, arguments);
      }
    };
  }
  
  function handleScroll() {
    const wrapperRect = imageWrapper.getBoundingClientRect();
    const triggerOffset = 58;
  
    if (wrapperRect.top <= triggerOffset && wrapperRect.bottom > triggerOffset) {
      const scrollY = window.scrollY; // 当前页面的总滚动值
      const sectionTop = scrollSection.offsetTop; // 整个滚动区域 scrollSection 距离页面顶部的偏移
      const scrollDistance = scrollY - sectionTop; // 在滚动区域中已经滚动了多少
  
      // 每张图切换间隔设为 50% 屏幕高度
      const scrollPerImage = window.innerHeight * 0.5;
  
      // 最大滚动距离应以 scrollPerImage 为单位
      const maxScroll = scrollPerImage * (numImages - 1);
  
      const effectiveScroll = Math.min(Math.max(scrollDistance, 0), maxScroll); // 限制在范围内
      const index = Math.floor(effectiveScroll / scrollPerImage); // 每 0.8 屏切换一张
  
      // 切换图片透明度（渐变效果通过 CSS 控制）
      images.forEach((img, i) => {
        img.style.opacity = i === index ? '1' : '0';
      });
  
      // 切换文案内容
      if (currentActiveIndex !== index) {
        currentActiveIndex = index;
        updateDescItems(currentActiveIndex);
      }
    }
  }
  
  function updateDescItems(newIndex) {
    descItems.forEach((item, j) => {
      const content = item.querySelector('.image-desc__item .item-body');
      if (!content) return;
  
      if (j === newIndex) {
        item.classList.add('active');
        
        // 先清除 max-height，避免旧值影响 scrollHeight
        content.style.maxHeight = 'none';
        const fullHeight = content.scrollHeight;
  
        content.style.maxHeight = '0'; // 回退为 0 以触发过渡
        content.offsetHeight; // 强制重绘
  
        // 平滑展开
        content.style.transition = 'max-height 0.6s ease, opacity 0.4s ease';
        content.style.maxHeight = fullHeight + 'px';
        content.style.opacity = '1';
  
      } else {
        item.classList.remove('active');
        content.style.maxHeight = content.scrollHeight + 'px'; // 设置当前高度作为起点
        content.offsetHeight; // 强制重绘
        content.style.maxHeight = '0';
        content.style.opacity = '0';
      }
    });
  }
  // 使用节流来控制滚动回调的触发频率
  window.addEventListener('scroll', throttle(handleScroll, 50)); // 设置为100ms节流
});
